export default "__VITE_ASSET__DWT$T_af__"